import _taggedTemplateLiteral from "/codebuild/output/src196865849/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  padding-bottom: 14px;\n  text-decoration: none;\n  ", " {\n    padding-bottom: 0;\n    min-width: 115px;\n    margin-right: ", "px;\n  }\n  &:last-of-type {\n    padding-bottom: 0;\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  list-style-type: none;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  margin-bottom: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n\n  ", " {\n    margin-bottom: 0;\n    margin-top: 0;\n    display: flex;\n    justify-content: flex-start;\n  }\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  text-align: center;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  ", " {\n    flex-direction: row-reverse;\n    justify-content: space-between;\n  }\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ", " {\n    justify-content: flex-start;\n  }\n\n  ", " {\n    margin-right: ", "px;\n    &:last-of-type {\n      margin-right: 0;\n    }\n  }\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n  svg {\n    width: ", "px;\n    height: ", "px;\n  }\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  text-align: center;\n  ", " {\n    text-align: left;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: 20.2px;\n  letter-spacing: 0.3px;\n  color: ", ";\n  line-height: 1.28;\n  margin-top: ", "px;\n  margin-bottom: 6px;\n  text-align: center;\n\n  ", " {\n    margin-top: 0;\n    text-align: left;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: ", "px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  ", " {\n    display: flex;\n    flex: 1 1 auto;\n    max-width: 562px;\n    margin-right: ", "px;\n    justify-content: space-between;\n  }\n\n  ", " {\n    margin-right: ", "px;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n\n  ", " {\n    display: flex;\n    align-items: flex-start;\n    flex: 1 1 auto;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    max-width: 427px;\n    margin: 0 auto;\n  }\n  ", " {\n    max-width: 310px;\n  }\n\n  ", " {\n    margin: unset;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    justify-content: space-between;\n  }\n  ", " {\n    justify-content: flex-end;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  margin-bottom: ", "px;\n  list-style-type: none;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  text-decoration: none;\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: 107px;\n\n  ", " {\n    margin: unset;\n  }\n\n  ", " {\n    max-width: 167px;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 29px;\n  padding-bottom: ", "px;\n\n  ", " {\n    padding-bottom: ", "px;\n  }\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    padding: 0 ", "px;\n  }\n  ", " {\n    padding: 0 ", "px;\n  }\n  ", " {\n    padding: 0 ", "px 18px;\n  }\n\n  ", " {\n    padding: 56px ", "px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-top: solid 1px ", ";\n  *:focus {\n    outline-color: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from "styled-components";
import { Col, Container as RawContainer } from "../Grid";
import { typography, size, colors, mediaQueries } from "../../shared/constants";
export var Footer = styled.footer(_templateObject(), colors.white, colors.green2, colors.teal4);
export var Container = styled(RawContainer)(_templateObject2(), mediaQueries.forTabletVerticallUp, size.xl3, mediaQueries.forTabletVerticalDown, size.lg, mediaQueries.forTabletHorizontalUp, size.xl1, mediaQueries.forDesktopUp, size.xl4);
export var MobileLogoWrapper = styled(Col)(_templateObject3(), size.md, mediaQueries.forTabletHorizontalUp, size.lg, mediaQueries.forDesktopUp);
export var Logo = styled.img(_templateObject4(), mediaQueries.forTabletHorizontalUp, mediaQueries.forDesktopUp);
export var FooterLink = styled.a(_templateObject5(), typography.buttonTextSmall, colors.green5, colors.teal5);
export var CategoryListItem = styled.li(_templateObject6(), typography.buttonTextSmall, size.md);
export var FlexCol = styled(Col)(_templateObject7(), mediaQueries.forTabletHorizontalUp, mediaQueries.forDesktopUp);
export var SubscribeAndSocialSection = styled.div(_templateObject8(), mediaQueries.forTabletVerticalUp, mediaQueries.forTabletHorizontalUp, mediaQueries.forDesktopUp);
export var DesktopLogoWrapper = styled.div(_templateObject9(), mediaQueries.forDesktopUp);
export var DesktopLinksWrapper = styled.div(_templateObject10(), mediaQueries.forTabletHorizontalUp, size.xl2, mediaQueries.forDesktopUp, size.xl4);
export var LinkSection = styled.div(_templateObject11());
export var CategoryTitle = styled.h3(_templateObject12(), typography.subtitle, colors.gray5, size.xs1);
export var SubscribeHeading = styled.h3(_templateObject13(), typography.weight.regular, colors.gray4, size.md, mediaQueries.forTabletHorizontalUp);
export var MobileAccordionCol = styled(Col)(_templateObject14(), mediaQueries.forTabletHorizontalUp);
export var SubscribeDescription = styled.p(_templateObject15(), typography.captionText, mediaQueries.forTabletHorizontalUp);
export var SubscribeInputWrapper = styled.div(_templateObject16(), size.xs1);
export var IconWrapper = styled.a(_templateObject17(), colors.green5, colors.teal5, size.md, size.md);
export var SocialIconsWrapper = styled.div(_templateObject18(), size.lg, mediaQueries.forTabletHorizontalUp, IconWrapper, size.xl1);
export var LegalSectionWrapper = styled.div(_templateObject19(), size.xl1, mediaQueries.forTabletHorizontalUp);
export var LegalText = styled.p(_templateObject20(), typography.captionText);
export var LegalLinkList = styled.ul(_templateObject21(), mediaQueries.forTabletHorizontalUp);
export var ListItem = styled.li(_templateObject22());
export var LegalLink = styled.a(_templateObject23(), typography.captionText, mediaQueries.forTabletHorizontalUp, size.md);